import { HelpCircle, Home, Users } from 'lucide-react';
import { DiscordIcon } from './DiscordIcon';

// The navigation of the mentor portal sidebar, one table instead of the two
// app/(hack)/26-{co,mx}/mentor/(protected)/_components/mentor-sidebar.tsx twins
// (PORTING.md G5). The only thing that differed between them is this table: Bogotá links
// its attendee list, Ciudad de México has no such page.

export type NavItem = {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  external: boolean;
};

const EDITIONS: Record<string, NavItem[]> = {
  '26-co': [
    {
      name: 'Dashboard',
      href: '/26-co/mentor/dashboard',
      icon: Home,
      external: false,
    },
    {
      name: 'Asistentes',
      href: '/26-co/mentor/attendees',
      icon: Users,
      external: false,
    },
  ],
  '26-mx': [
    {
      name: 'Dashboard',
      href: '/26-mx/mentor/dashboard',
      icon: Home,
      external: false,
    },
  ],  '26-ve': [
    {
      name: 'Dashboard',
      href: '/26-ve/mentor/dashboard',
      icon: Home,
      external: false,
    },
  ],
};

export function buildNavigation(
  edition: string | null,
  discordGuildId: string | null,
  discordFaqChannelId: string | null,
): NavItem[] {
  const items: NavItem[] = [...((edition && EDITIONS[edition]) || [])];

  if (discordGuildId) {
    items.push({
      name: 'Discord',
      href: `https://discord.com/channels/${discordGuildId}`,
      icon: DiscordIcon,
      external: true,
    });
    if (discordFaqChannelId) {
      items.push({
        name: 'FAQ',
        href: `https://discord.com/channels/${discordGuildId}/${discordFaqChannelId}`,
        icon: HelpCircle,
        external: true,
      });
    }
  }

  return items;
}

export function isItemActive(pathname: string, href: string) {
  return (
    pathname === href ||
    pathname.startsWith(`${href}/`) ||
    pathname.endsWith(href)
  );
}
